import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {

  private readonly TTL_MS = 24 * 60 * 60 * 1000; // 24h
  private readonly KEY = 'sw_last_update_check';

  constructor(private swUpdate: SwUpdate) {}

  init() {
    if (!this.swUpdate.isEnabled) return;

    const last = Number(localStorage.getItem(this.KEY) || '0');
    const now = Date.now();

    if (now - last > this.TTL_MS) {
      localStorage.setItem(this.KEY, String(now));
      this.swUpdate.checkForUpdate();
    }

    this.swUpdate.versionUpdates
      .pipe(filter((e: any) => e.type === 'VERSION_READY'))
      .subscribe(() => {
        if (confirm('Nova versão do sistema disponível. Atualizar agora?')) {
          window.location.reload();
        }
      });
  }
}